import SearchIcon from '@mui/icons-material/Search';
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { outlinedFieldSx, searchFieldSx } from '../styles/formControlStyles';
import { mergeSx } from '../utils/mergeSx';

/** `compact` is toolbar height (32px). `default` matches other form fields (36px). */
export type SearchFieldDensity = 'default' | 'compact';

export type SearchFieldProps = Omit<MuiTextFieldProps, 'label' | 'InputProps' | 'inputProps'> & {
  placeholder: string;
  density?: SearchFieldDensity;
};

const SearchField = ({
  placeholder,
  sx,
  slotProps,
  size = 'small',
  density = 'compact',
  ...props
}: SearchFieldProps) => {
  const htmlInputSlot =
    typeof slotProps?.htmlInput === 'object' ? slotProps.htmlInput : undefined;
  const inputSlot = typeof slotProps?.input === 'object' ? slotProps.input : undefined;

  return (
    <MuiTextField
      size={size}
      placeholder={placeholder}
      slotProps={{
        ...slotProps,
        htmlInput: {
          ...htmlInputSlot,
          'aria-label': htmlInputSlot?.['aria-label'] ?? placeholder,
        },
        input: {
          ...inputSlot,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={mergeSx(outlinedFieldSx, density === 'compact' ? searchFieldSx : undefined, sx)}
      {...props}
    />
  );
};

export default SearchField;
